import { render } from "./ViewStatisticsPage.vue?vue&type=template&id=f2448a86&scoped=true"
import script from "./ViewStatisticsPage.vue?vue&type=script&lang=js"
export * from "./ViewStatisticsPage.vue?vue&type=script&lang=js"

import "./ViewStatisticsPage.vue?vue&type=style&index=0&id=f2448a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2448a86"]])

export default __exports__